import React from 'react';
import styles from './page7.scss';
import pic from './pic.png';
import { getRem } from '../../func';

function Page7(props) {
  return (
    <div className={styles['page7']} ref={props.myRef}>
      <div className={styles['page7-main']}>
        <div className={`${styles['page7-title']} animate2-wrapper`}>
          <div r='220' g='221' b='235' className={`maskBlock animate2`} style={{ background: 'rgb(220, 221, 235)' }} />
          BRAND CUSTOMERS
        </div>

        <div className={styles['page7-subTitle']}>
          <div className={styles['page7-subTitle-circle']}>4</div>
          <div className={styles['page7-subTitle-text']}>品牌人群</div>
        </div>

        <div className={styles['page7-content']}>
          <div className={styles['page7-content-left']}>
            <div className={styles['page7-content-left-item']}>
              <div className={styles['page7-content-left-item-num']}>1</div>
              <div>热爱并深耕于时尚产业的 <span style={{ color: '#32535D' }}>时髦分子</span></div>
            </div>

            <div className={styles['page7-content-left-item']}>
              <div className={styles['page7-content-left-item-num']}>2</div>
              <div>寻求更多设计灵感及素材咨询的 <span style={{ color: '#32535D' }}>设计圈人士</span></div>
            </div>

            <div className={styles['page7-content-left-item']}>
              <div className={styles['page7-content-left-item-num']}>3</div>
              <div>注重美学品味提升和深度内容索取的 <span style={{ color: '#32535D' }}>企业精英</span></div>
            </div>

            <div className={styles['page7-content-left-item']}>
              <div className={styles['page7-content-left-item-num']}>4</div>
              <div>拥有自我审美及全球化视野的 <span style={{ color: '#32535D' }}>领军企业</span></div>
            </div>
          </div>

          <div className={styles['page7-content-right']}>
            <img src={pic} style={{ width: getRem(549), height: getRem(356) }} />

            <div className={styles['page7-content-right-desc']}>
              我们的用户构成多维度涵盖服装品牌、电商、<br />
              面料商、批发商的主理人、设计总监、企划主管等优质圈层人群
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Page7;